"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setPropsAtPath = void 0;

var setPropsAtPath = function setPropsAtPath(fieldData, props, path) {
  var current = fieldData;
  var previousBranch;
  var usedProps = false;
  var size = path.length;

  for (var index = 0; index < size; index++) {
    var branch = path[index];

    if (!isNaN(previousBranch) && branch === 'fields') {
      index++;
      branch = path[index];
    }

    if (!usedProps && branch === 'items') {
      usedProps = true;
      current = current.props;
    }

    if (index === size - 1) {
      current[branch] = usedProps ? props.props : props;
    } else {
      previousBranch = branch;
      current = current[branch];
    }
  }

  return fieldData;
};

exports.setPropsAtPath = setPropsAtPath;